import {parseISO} from "date-fns";
import {longStringWithDayName} from "../services/date/formatters";
import CheckInItem from "./CheckInItem";


/*
 * A full version of a Guest object
 */
export default class CheckIn {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.bookingId = apiResponse.bookingId;
        this.checkInDate = parseISO(apiResponse.checkInDate);
        this.expectedCheckOutDate = parseISO(apiResponse.expectedCheckOutDate);
        this.syncAlloggiati = Boolean(apiResponse.syncAlloggiati);
        this.syncAbit = Boolean(apiResponse.syncAbit);
        this.alloggiatiJobStatus = apiResponse.alloggiatiJobStatus;
        this.alloggiatiJobError = apiResponse.alloggiatiJobError;
        this.abitArrivalsStatus = apiResponse.abitArrivalsStatus;
        this.abitDeparturesStatus = apiResponse.abitDeparturesStatus;
        this.checkInItems = apiResponse.checkInItems ? apiResponse.checkInItems.map(ci => new CheckInItem(ci)) : [];
    }

    clone() {
        const checkIn = new CheckIn({});
        checkIn.id = this.id;
        checkIn.bookingId = this.bookingId;
        checkIn.checkInDate = this.checkInDate ? new Date(this.checkInDate) : null;
        checkIn.expectedCheckOutDate = this.expectedCheckOutDate ? new Date(this.expectedCheckOutDate) : null;
        checkIn.syncAlloggiati = this.syncAlloggiati;
        checkIn.syncAbit = this.syncAbit;
        checkIn.alloggiatiJobStatus = this.alloggiatiJobStatus;
        checkIn.alloggiatiJobError = this.alloggiatiJobError;
        checkIn.abitArrivalsStatus = this.abitArrivalsStatus;
        checkIn.abitDeparturesStatus = this.abitDeparturesStatus;
        checkIn.checkInItems = this.checkInItems.map(ci => ci.clone());
        return checkIn;
    }

    getCheckInDateString() {
        return longStringWithDayName(this.checkInDate);
    }

    getExpectedCheckOutDateString() {
        return longStringWithDayName(this.expectedCheckOutDate);
    }
}